const sessionExpirationSubscriptionName = 'sessionExpirationNotify';

export const sessionExpirationNotify = [`
  subscription ${sessionExpirationSubscriptionName}{ 
    ${sessionExpirationSubscriptionName} 
}`, sessionExpirationSubscriptionName];